
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from 'react-query';
import request from '@utils/request';
import { PLACE_ENUM, FULL_SIZE_COLUMN } from '@utils/constants';
import { Spin, Card, Row, Col, Button, Table, Select } from 'antd';
import FileSaver from 'file-saver';
import domtoimage from 'dom-to-image';
import { formatNumber, awaitWrapper, initProductMeta, groupBy } from '@utils/helper';
import './style.less';
import UpdateSapo from './UpdateSapo';

const {Option} = Select;
const CAMPAIGN = '20260616';
const PRODUCTS = [
  // { code: 'DTBLTTLK', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTMLTCT', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DTBLTTSV', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTDTI', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLAXKN', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTMLCNB', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTDD', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DNKSTSH', salePrice: 1215000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTPLD', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTTTHX', salePrice: 1215000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DNSMD', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DMDVN', salePrice: 765000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTHHN', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTMDD', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTCTHD', salePrice: 1215000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTTTXN', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTHM', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTHTDT', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DTBHV', salePrice: 801000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DGTLTTDC', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DTBLTTSD', salePrice: 1062000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTARSV', salePrice: 1125000, salePercent: 10, saleGroup: '10%' },
  // { code: 'DLTTPLV', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTMLXN', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTLC', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLNKHK', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLNVKN', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTHHXL', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DTBLMD', salePrice: 712000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTNV', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DTSE', salePrice: 736000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DDL', salePrice: 680000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTHV', salePrice: 768000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTTAD', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTKND', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTKNX', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DMDXNV', salePrice: 680000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DLTTTDXHS', salePrice: 1352000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DTBDML', salePrice: 712000, salePercent: 20, saleGroup: '20%' },
  // { code: 'DTBLTTHT', salePrice: 944000, salePercent: 20, saleGroup: '20%' },
  { code: 'DTMDN', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DLTTDMDX', salePrice: 826000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DLTTXCB', salePrice: 826000, salePercent: 30, saleGroup: '30%' },
  { code: 'DNMDV', salePrice: 644000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DTBMC', salePrice: 672000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHTGH', salePrice: 616000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DCVH', salePrice: 644000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DLTTDMDD', salePrice: 826000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DHVNN', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTXLDC', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTHND', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTOSXL', salePrice: 595000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHDMX', salePrice: 644000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHTMD', salePrice: 595000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTHHD', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DPH', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DMDHTD', salePrice: 616000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTOHMD', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTOMDCH', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHTADD', salePrice: 616000, salePercent: 30, saleGroup: '30%' },
  { code: 'DMDDC', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTOTND', salePrice: 602000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTODH', salePrice: 602000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTLKX', salePrice: 553000, salePercent: 30, saleGroup: '30%' },
  { code: 'DCDC', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DHHNX', salePrice: 595000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DHHDC', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTBHO', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTXDD', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHCMX', salePrice: 644000, salePercent: 30, saleGroup: '30%' },
  { code: 'DTMML', salePrice: 672000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHCOMX', salePrice: 644000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DLTTCNC', salePrice: 672000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHNT', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  // { code: 'DLLLD', salePrice: 574000, salePercent: 30, saleGroup: '30%' },
  { code: 'DHTP', salePrice: 425000, salePercent: 50, saleGroup: '50%' },
  { code: 'DHDLHX', salePrice: 445000, salePercent: 50, saleGroup: '50%' },
  { code: 'DLHHTI', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
  { code: 'DLLHD', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
  { code: 'DHTV', salePrice: 425000, salePercent: 50, saleGroup: '50%' },
  { code: 'DBBV', salePrice: 445000, salePercent: 50, saleGroup: '50%' },
  { code: 'DTXDX', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
  { code: 'DCDDC', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
  { code: 'DLLHX', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
  // { code: 'DLTTMDTNV', salePrice: 480000, salePercent: 50, saleGroup: '50%' },
  // { code: 'DLTTHD', salePrice: 645000, salePercent: 50, saleGroup: '50%' },
  // { code: 'DSND', salePrice: 410000, salePercent: 50, saleGroup: '50%' },
]


function Campaign(props) {
  const [loading, setLoading] = useState(false);
  const [productList, setProductList] = useState([]);
  const [dataSource, setDataSource] = useState([]);
  const [showBanner, setShowBanner] = useState(false);
  const [showGrid, setShowGrid] = useState(false);
  const [gridPage, setGridPage] = useState(1);
  const [groupList, setGroupList] = useState([]);
  const [groupValue, setGroupValue] = useState('');
  const [mainPageIndex, setMainPageIndex] = useState(0);
  const [isDownloading, setIsDownloading] = useState(false);
  let tDoDownloadAll = null;
  const { isLoading, mutate: getProductList } = useMutation(() => {
    return request.get('v1/product-meta');
  },
    {
      onSuccess: (response) => {
        const productList = initProductMeta(response.data);
        setProductList(productList);
        initData(productList);
        const groupList = groupBy(PRODUCTS, 'saleGroup');
        setGroupList(groupList);
        if(groupList.length > 0){
          setGroupValue(groupList[0]);
        }
      },
    });
  useEffect(() => {
    getProductList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])
  const initData = (productList) => {
    const data = [];
    PRODUCTS.forEach(p => {
      const sku = p.code.toLowerCase();
      const item = productList.find(x => x.pSku === sku);
      if (item) {
        // const salePercent = 100 - Math.round(p.salePrice / item.price * 100);
        // if(salePercent >= 40){
        const newItem = {
          ...item,
          salePrice: p.salePrice,
          salePercent: p.salePercent,
          saleGroup: p.saleGroup,
          stock: p.stock || item.inventoryQuantity,
          sell: p.sell
        }
        if(!item.image && p.url){
          newItem.image = p.url;
        }
        data.push(newItem);
        // }
      }
    })
    setDataSource(data);
  }
  const updateWoo = async (product = {}, resetPrice = false) => {
    if (!product.wooProductId) return false;
    const getVariationData = {
      url: `products/${product.wooProductId}`,
      method: 'get'
    }
    const [gErr, gRes] = await awaitWrapper(request.post('/v1/wp-woo', getVariationData));
    if (!gErr) {
      const wooProduct = gRes.data;
      const variations = wooProduct.variations || [];
      const updateData = [];
      for (let i = 0; i < variations.length; i++) {
        updateData.push({
          id: variations[i],
          sale_price: resetPrice ? `${product.price}` : `${product.salePrice}`,
        })
      }
      const data = {
          url: `products/${product.wooProductId}/variations/batch`,
          method: 'post',
          data: {
            update: updateData
          }
        }
      await awaitWrapper(request.post('/v1/wp-woo', data));
      // for (let i = 0; i < variations.length; i++) {
      //   const data = {
      //     url: `products/${product.wooProductId}/variations/${variations[i]}`,
      //     method: 'put',
      //     data: {
      //       sale_price: resetPrice ? `${product.price}` : `${product.salePrice}`,
      //     }
      //   }
      //   await awaitWrapper(request.post('/v1/wp-woo', data));
      // }
    }
  }

  const handleUpdate = async (resetPrice = false) => {
    setLoading(true);
    const pList = [];
    PRODUCTS.forEach(p => {
      const sku = p.code.toLowerCase();
      const item = productList.find(x => x.pSku === sku);
      if (item) {
        pList.push({
          ...item,
          salePrice: p.salePrice
        })
      }
    })
    for (let i = 0; i < pList.length; i++) {
      await updateWoo(pList[i], resetPrice);
    }
    setLoading(false);
  }
  const handleImageLoaded = () => {
    if (isDownloading) {
      handleDownload();
      clearTimeout(tDoDownloadAll);
      const nextTick = Math.round(Math.random() * 1000 + 1000);
      tDoDownloadAll = setTimeout(() => { doDownloadAll(); }, nextTick);
    }
    console.log('image loaded');
  }
  const handleDownloadAll = async () => {
    if (isDownloading) {
      setIsDownloading(false);
    } else {
      setIsDownloading(true);
      // setMainPageIndex(67);
      doDownloadAll();
    }
  }
  const doDownloadAll = async () => {
    if (mainPageIndex >= PRODUCTS.length) {
      setIsDownloading(false);
      return;
    }
    if (mainPageIndex < PRODUCTS.length - 1) {
      let ind = dataSource.findIndex((item, i) => {
        return i > mainPageIndex && item.image;
      })
      // let ind = mainPageIndex + 1;
      const p = PRODUCTS[ind];
      if (!p) ind += 1;
      else {
        const sku = p.code.toLowerCase();
        const item = productList.find(x => x.pSku === sku);
        if (!item.image) {
          ind += 1;
        }
      }

      setMainPageIndex(ind);
    } else {
      setIsDownloading(false);
    }
    return;
  }
  const handleDownload = async () => {
    var node = document.querySelector('.productBanner');
    const name = node.getAttribute('data-name');
    // const name = 'TEST';
    domtoimage.toBlob(node)
      .then(function (blob) {
        FileSaver.saveAs(blob, `${name}.png`);
      });
  }
  const handleShowBanner = () => {
    if (!showBanner) {
      setMainPageIndex(0);
    }
    setShowBanner(!showBanner);
  }
  const handleClickItem = (itemInd => {
    setMainPageIndex(itemInd);
    if (!showBanner) setShowBanner(true);
  })
  const columns = [
    {
      title: '',
      dataIndex: 'id',
      render: (value) => PLACE_ENUM[value]
    },  
  ]
  FULL_SIZE_COLUMN.forEach(s => {
    columns.push({
      title: s,
      dataIndex: s
    })
  })

  const handleDownloadGrid = async () => {
    var node = document.querySelector('.productGrid');
    const name = node.getAttribute('data-name');
    domtoimage.toBlob(node)
      .then(function (blob) {
        FileSaver.saveAs(blob, `${name}.png`);
      });
  }

  const renderProductGridItem = (item) => {
    const orgPrice = item.price / 1000;
    const salePrice = Math.round(item.salePrice / 1000);
    const imageSrc = item.image ? item.image.replace('https://otina.n4u.vn/', 'https://otina-proxy.n4u.vn/') : '';
    let sku = item.pSku.toUpperCase();
    return (
      <div className='item' style={{ backgroundImage: `url(${imageSrc})` }}>
        <div className='sku'>{sku}</div>
        <div className='price'>
          <span className='salePrice'>{`${orgPrice}k`}</span>
          <span>{` - `}</span>
          <span className='salePrice'>{item.stock}</span>
          {/* <span>{` - `}</span>
          <span className='salePrice'>{item.sell}</span> */}
        </div>
        {/* {item.saleGroup < 100 && (<div className='price'>
          <span className='orgPrice'>{`${orgPrice}k`}</span>
          <span>{` → `}</span>
          <span className='salePrice'>{salePrice}k</span>
        </div>)} */}
      </div>
    )
  }

  const renderProductGrid = () => {
    const startInd = (gridPage - 1)*10;
    const endInd = gridPage*10;
    const groupList = dataSource.filter(x => x.saleGroup === groupValue && x.image);
    const list = groupList.slice(startInd, endInd);
    return (
      <div className='productGrid' data-name={`${CAMPAIGN}-${groupValue}-page-${gridPage}`}>
        <div className='productGridTile'>{groupValue < 100 ? groupValue + '%' : groupValue}</div>
        {list.map((item) => renderProductGridItem(item))}
      </div>
    )
  }

  const renderProductDetail = (item, ind) => {
    // const sku = p.code.toLowerCase();
    // const item = productList.find(x => x.pSku === sku);
    // if (!item) return '';
    const cover = (
      <p>
        <img alt={item.pName} src={item.image} />
      </p>
    );
    return (
      <Col sm={6} style={{ marginBottom: 16 }} key={item.pSku}>
        <Card className='productItem' hoverable cover={cover} onClick={() => handleClickItem(ind)}>
          <div style={{ height: 42 }}>{item.pName} - {item.pSku}</div>
          <div style={{ fontSize: 20 }}>{formatNumber(item.price)}{` => `}<b>{formatNumber(item.salePrice)}</b> - <b>{item.saleGroup}</b></div>
          <UpdateSapo list={dataSource} singleMode={true} item={item} />
          <div>
            <Table 
              dataSource={item.inventory} 
              columns={columns} 
              className='metaTable'
              bordered={false}
              pagination={false}
              size="small" 
              locale={{emptyText: '-'}}
            />
          </div>
        </Card>
      </Col>
    )
  }
  // const renderProductGrid = () => {
  //   if(!dataSource.length) return '';
  //   const COL = 4;
  //   const ROW = 2;
  //   const page = Math.ceil(productSource.length / (COL * ROW));
  //   return (
  //     <div>
  //       {[...Array(page).keys()].map(pageNumber => (

  //       ))}
  //     </div>
  //   )
  // }
  const renderProductBanner = () => {
    if (mainPageIndex < 0) return '';
    // const p = PRODUCTS[mainPageIndex];
    // if (!p) return '';
    // const sku = p.code.toLowerCase();
    // const item = productList.find(x => x.pSku === sku);
    const item = dataSource[mainPageIndex];
    if (!item) return '';
    const orgPrice = item.price / 1000;
    const salePrice = Math.round(item.salePrice / 1000);
    const {gallery} = item;
    let image = item.image || '';
    if(gallery){
      const galleries = gallery.split(',');
      if(galleries.length){
        const imgInd = Math.floor(Math.random() * galleries.length);
        image = galleries[imgInd];
      }
    }
    if(image) image = image.replace('https://otina.n4u.vn/', 'https://otina-proxy.n4u.vn/');
    const imageSrc = image;// item.image ? item.image.replace('https://otina.n4u.vn/', 'https://otina-proxy.n4u.vn/') : '';
    let minorImage = imageSrc;
    if (item.gallery && item.gallery.indexOf(',') > 0) {
      const galleries = item.gallery.split(',');
      minorImage = galleries[0].replace('https://otina.n4u.vn/', 'https://otina-proxy.n4u.vn/');
    }
    let sku = item.pSku.toUpperCase();
    const name = item.pName;
    let skuLink = sku;
    if(item.wooProductId){
      skuLink = <a target="_blank" rel="noopener noreferrer" href={`https://otina.n4u.vn/wp-admin/post.php?post=${item.wooProductId}&action=edit`}>{sku}</a>;
    }
    return (
      <div className='productBanner' data-percent={item.salePercent} data-name={`${item.salePercent}-${item.salePrice/1000}-${CAMPAIGN}-${sku.toUpperCase()}`}>
        <div className='imageFrame' style={{ backgroundImage: `url(${imageSrc})` }}></div>
        <img className='imageSrc' alt={name} src={imageSrc} onLoad={handleImageLoaded} />
        <div className='priceArea'>
          <div className='price'>
            <span className='orgPrice'>
              {`${orgPrice}k`}
            </span>
            {/* <span>{`⇩`}</span> */}
            <span className='salePrice'>{salePrice}k</span>
          </div>
        </div>
        <div className='salePercent'>{item.salePercent}</div>
        <div className='sku'>{sku.toUpperCase()}</div>
      </div>
    )
  }
  return (
    <Spin spinning={isLoading}>
      <Row gutter={16}>
        <Col sm={12}>
          <h2>Sale {CAMPAIGN}</h2>
        </Col>
        <Col sm={6}>
          <Button onClick={handleShowBanner}>{showBanner ? 'Hide Banner' : 'Show Banner'}</Button>
          {showBanner &&
            <Button onClick={handleDownloadAll}>{isDownloading ? `Downloading (${mainPageIndex + 1}/${PRODUCTS.length})` : `Download All`}</Button>
          }
          <Button onClick={() => {setShowGrid(!showGrid)}}>{showGrid ? 'Hide Grid' : 'Show Grid'}</Button>
          {showGrid &&
            <Button onClick={handleDownloadAll}>{isDownloading ? `Downloading (${mainPageIndex + 1}/${PRODUCTS.length})` : `Download All`}</Button>
          }
        </Col>
        <Col sm={6}>
          <Button loading={loading} disabled={loading} onClick={() => handleUpdate(false)}>Update Price</Button>
          <Button loading={loading} disabled={loading} onClick={() => handleUpdate(true)}>Reset Price</Button>
          <UpdateSapo list={dataSource} />
        </Col>
      </Row>
      {showGrid && (
        <Row gutter={16}>
          <Col sm={2} align="right">
            <Select style={{ marginTop: 20, width: '100%' }}  value={groupValue} onChange={v => {setGroupValue(v); setGridPage(1);}}>
              {groupList.map(x => (
                <Option key={x} value={x}>{x}</Option>
              ))}
            </Select>
            <Button disabled={gridPage < 2} onClick={() => setGridPage(gridPage - 1)}>Previous</Button>
            <Button onClick={handleDownloadGrid}>Download</Button>
          </Col>
          <Col sm={20}>{renderProductGrid()}</Col>
          <Col sm={2}>
          <Button style={{ marginTop: 20 }} disabled={mainPageIndex > PRODUCTS.length - 2} onClick={() => setGridPage(gridPage + 1)}>Next</Button>
        </Col>
        </Row>
      )}
      {showBanner && (<Row gutter={16}>
        <Col sm={2} align="right">
          <Button style={{ marginTop: 20 }} disabled={mainPageIndex < 1} onClick={() => setMainPageIndex(mainPageIndex - 1)}>Previous</Button>
          <Button onClick={handleDownload}>Download</Button>
        </Col>
        <Col sm={20}>
          <div>
            {renderProductBanner()}
          </div>
        </Col>
        <Col sm={2}>
          <Button style={{ marginTop: 20 }} disabled={mainPageIndex > PRODUCTS.length - 2} onClick={() => setMainPageIndex(mainPageIndex + 1)}>Next</Button>
        </Col>
      </Row>)}
      <Row gutter={16}>
        {dataSource.map(renderProductDetail)}
      </Row>
    </Spin>
  )
}

Campaign.propTypes = {
  dataSource: PropTypes.array,
  categoryList: PropTypes.array,
  loading: PropTypes.bool,
};

Campaign.defaultProps = {
  dataSource: [],
  categoryList: [],
  loading: false,
};

export default Campaign;
